import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import Landing from "./pages/Landing";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";
import MakeAWill from "./pages/MakeAWill";
import DiyPlanner from "./pages/DiyPlanner";
import RiskProfiler from "./pages/RiskProfiler";
import SifControlLayout from "./pages/sifcontrol/Layout";
import SifControlHome from "./pages/sifcontrol/Home";
import SifControlRankings from "./pages/sifcontrol/Rankings";
import SifControlScreener from "./pages/sifcontrol/Screener";
import SifControlCompare from "./pages/sifcontrol/Compare";
import SifControlSifList from "./pages/sifcontrol/SifList";
import SifControlSifDetail from "./pages/sifcontrol/SifDetail";
import SifControlAmcList from "./pages/sifcontrol/AmcList";
import SifControlAmcDetail from "./pages/sifcontrol/AmcDetail";
import SifControlAmcLogin from "./pages/sifcontrol/AmcLogin";
import SifControlAmcDashboard from "./pages/sifcontrol/AmcDashboard";
import SifControlAmcUpload from "./pages/sifcontrol/AmcUpload";
import SifControlAmcUploads from "./pages/sifcontrol/AmcUploads";
import { useVersionDriftReloader } from "./lib/useVersionDriftReloader";
import GAListener from "./components/GAListener";

function App() {
    // Polls /api/version every minute. If the deployed backend has rolled to a
    // new version but the running JS bundle is still the previous one, the
    // user sees a toast and the page auto-reloads with a cache-buster after
    // 10s. This is the in-app substitute for nginx Cache-Control on index.html.
    useVersionDriftReloader();

    return (
        <BrowserRouter>
            <GAListener />
            <Toaster
                position="top-center"
                toastOptions={{
                    style: {
                        background: "rgba(245,245,242,0.92)",
                        color: "#0A0A0A",
                        border: "1px solid rgba(217,215,209,0.7)",
                        borderRadius: "16px",
                        backdropFilter: "blur(18px)",
                        fontFamily: "Inter Tight, sans-serif",
                    },
                }}
            />
            <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/makeawill" element={<MakeAWill />} />
                <Route path="/diy" element={<DiyPlanner />} />
                <Route path="/diy/plan/:code" element={<DiyPlanner />} />
                <Route path="/riskprofiler" element={<RiskProfiler />} />
                <Route path="/adminoth" element={<AdminLogin />} />
                <Route path="/admin" element={<AdminDashboard />} />

                {/* SIF Control by One Tree Hill.
                    React Router v6+ matches path case-insensitively by default
                    (caseSensitive: false), so /SifControl, /sifcontrol and
                    /SIFCONTROL all resolve to the same tree — no redirects
                    needed. */}
                <Route path="/sifcontrol" element={<SifControlLayout />}>
                    <Route index element={<SifControlHome />} />
                    <Route path="rankings" element={<SifControlRankings />} />
                    <Route path="screener" element={<SifControlScreener />} />
                    <Route path="compare" element={<SifControlCompare />} />
                    <Route path="sifs" element={<SifControlSifList />} />
                    <Route path="sif/:id" element={<SifControlSifDetail />} />
                    <Route path="amcs" element={<SifControlAmcList />} />
                    <Route path="amc/:id" element={<SifControlAmcDetail />} />
                    <Route path="amc/login" element={<SifControlAmcLogin />} />
                    <Route path="amc/dashboard" element={<SifControlAmcDashboard />} />
                    <Route path="amc/upload" element={<SifControlAmcUpload />} />
                    <Route path="amc/uploads" element={<SifControlAmcUploads />} />
                    <Route path="amc/uploads/:id" element={<SifControlAmcUploads />} />
                    {/* SIF Control admin is served by the existing OTH admin at /admin */}
                    <Route path="admin" element={<Navigate to="/admin?tab=sifcontrol" replace />} />
                    <Route path="admin/login" element={<Navigate to="/adminoth" replace />} />
                </Route>
            </Routes>
        </BrowserRouter>
    );
}

export default App;
